import { App } from 'vue';
import { VueBemCn } from '@/utils/bem';

export const BemPlugin = {
  install(app: App) {
    app.config.globalProperties.b = function(element?: string, modifiers?: any) {
      // Get component name from this context
      const componentName = this.$options.name || 'component';
      // Convert component name to kebab-case for CSS class
      const blockName = componentName.replace(/([A-Z])/g, '-$1').toLowerCase().replace(/^-/, '');
      
      const bem = VueBemCn(blockName);
      
      if (element && element !== '') {
        return bem.e(element, modifiers);
      }
      if (modifiers) {
        return bem.m(modifiers);
      }
      return bem.b();
    };
  }
};
